export var SearchQueryLength;
(function (SearchQueryLength) {
    SearchQueryLength[SearchQueryLength["OneSymbolSearch"] = 1] = "OneSymbolSearch";
    SearchQueryLength[SearchQueryLength["TwoSymbolSearch"] = 2] = "TwoSymbolSearch";
    SearchQueryLength[SearchQueryLength["ThreeSymbolSearch"] = 3] = "ThreeSymbolSearch";
})(SearchQueryLength || (SearchQueryLength = {}));
//# sourceMappingURL=SearchQueryLength.js.map